import React from "react";
import footerImage from "../../assets/images/logo-1.png";
import { Link } from "react-router-dom";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";

const footerLinks = [
  [
    { to: "/all-products", label: "সব পণ্য" },
    { to: "/borka", label: "বোরকা" },
    { to: "/hijab", label: "হিজাব" },
  ],
  [
    { to: "/gallery", label: "গ্যালারী" },
    { to: "/reviews", label: "রিভিউ" },
    { to: "/tutorials", label: "টিউটোরিয়াল" },
  ],
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-black/5 bg-[#f4efe6]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 lg:grid-cols-[1.2fr_0.8fr_1fr] lg:px-8">
        <div className="space-y-5">
          <img
            src={footerImage}
            alt="ইসলামিক পোশাক"
            className="h-14 w-14 rounded-2xl object-contain"
          />
          <div>
            <h2 className="brand-serif text-4xl font-bold text-slate-950">
              আধুনিক মডেস্ট ফ্যাশন
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-slate-600">
              প্রিমিয়াম স্টোরফ্রন্ট, গেস্ট চেকআউট, এবং অনলাইন ও স্টোর অর্ডারের
              জন্য দ্রুত সাপোর্ট।
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href="tel:01918-090266" className="primary-button">
              <IoCallOutline className="mr-2 h-4 w-4" /> কল করুন
            </a>
            <a
              href="https://wa.me/+8801918090266"
              target="_blank"
              rel="noreferrer"
              className="secondary-button"
            >
              <FaWhatsapp className="mr-2 h-4 w-4" /> হোয়াটসঅ্যাপ
            </a>
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-3">
          {footerLinks.map((group, index) => (
            <div key={index} className="space-y-4">
              <p className="text-sm font-semibold uppercase tracking-[0.22em] text-slate-500">
                {index === 0 ? "কালেকশন" : "রিসোর্স"}
              </p>
              <div className="grid gap-3 text-sm text-slate-600">
                {group.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="transition hover:text-emerald-700"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
          <div className="space-y-4">
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-slate-500">
              সাপোর্ট
            </p>
            <p className="text-sm leading-7 text-slate-600">
              সাপোর্ট সময়: ২৪/৭ অনলাইন
            </p>
            {/* <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 transition hover:text-emerald-700">অ্যাডমিন লগইন</Link> */}
            <a
              href="https://www.facebook.com/islamiposhak"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold text-slate-700 transition hover:text-emerald-700"
            >
              <FaFacebookF className="h-4 w-4" /> ফেসবুক
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-black/5 bg-white/50">
        <div className="mx-auto flex max-w-7xl flex-row gap-3 px-4 py-5 text-xs text-slate-500 lg:px-8 justify-center">
          <p>কপিরাইট {new Date().getFullYear()} ইসলামিক পোশাক।</p>
          {/* <p>গেস্ট চেকআউট, প্রিমিয়াম ফ্যাশন, ওমনি-চ্যানেল অর্ডার।</p> */}
        </div>
      </div>
    </footer>
  );
}
